// extracted by mini-css-extract-plugin
module.exports =  {"shareCell":"aVkcOpEpRu3dkGbMbubD"};